import api from "@/lib/api";
import { toast } from "sonner";

export async function downloadAcceptancePdf(acceptanceId) {
  try {
    const res = await api.get(`/legal/acceptances/${acceptanceId}/pdf`, { responseType: "blob" });
    const cd = res.headers?.["content-disposition"] || "";
    const name = (cd.match(/filename="([^"]+)"/) || [])[1] || "cyannect-agreement.pdf";
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch {
    toast.error("Could not download the PDF.");
  }
}
